"use strict";

exports.__esModule = true;
exports.inlineLinkWrapper = exports.inlineLinkUnderline = exports.inlineLink = void 0;

var _styledComponents = require("styled-components");

var _system = require("./system");

var _hexToRgba = _interopRequireDefault(require("./hex-to-rgba"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var inlineLinkUnderline = function inlineLinkUnderline(textColor, fontWeight) {
  if (textColor === void 0) {
    textColor = "gray-dark";
  }

  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["border-bottom:1px solid ", ";border-left:none;border-radius:0;border-right:none;border-top:none;color:", ";font-weight:", ";padding:0;&:hover{border-color:", ";color:", ";}"], function (props) {
    return (0, _system.colors)(textColor, props);
  }, function (props) {
    return (0, _system.colors)(textColor, props);
  }, fontWeight, function (props) {
    return (0, _system.colors)("dark-aqua", props);
  }, function (props) {
    return (0, _system.colors)("dark-aqua", props);
  });
};

exports.inlineLinkUnderline = inlineLinkUnderline;

var inlineLink = function inlineLink(hoverColor, color) {
  return (0, _styledComponents.css)(["&:hover{border-color:", ";color:", ";}border:1px solid ", ";border-radius:3px;color:", ";display:inline-block;font-weight:600;padding:0 3px 2px 3px;text-decoration:none;", ";"], (0, _hexToRgba["default"])(color, 0.5), hoverColor, (0, _hexToRgba["default"])(color, 0.1), color, (0, _utils.transitionEase)("0.2s", ["border-color", "color"]));
};

exports.inlineLink = inlineLink;
var inlineLinkWrapper = (0, _styledComponents.css)(["", ";"], function (props) {
  return props.textColor === "dark" ? inlineLink((0, _system.colors)("dark-aqua", props), (0, _system.colors)("gray-sub", props)) : inlineLink((0, _system.colors)(props.textColor, props), (0, _system.colors)(props.textColor, props));
});
exports.inlineLinkWrapper = inlineLinkWrapper;